import { render, staticRenderFns } from "./Agencia.vue?vue&type=template&id=21057d16&"
import script from "./Agencia.vue?vue&type=script&lang=js&"
export * from "./Agencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports